(function () {
  var CLS   = 'dt-excl-vat';
  var LOGIN = 'dt-login-prompt';

  /* Detect guest: server-side CSS set visibility:hidden on price elements */
  function isGuest() {
    var el = document.querySelector('.price-list--lg, sale-price.text-subdued');
    return el && getComputedStyle(el).visibility === 'hidden';
  }

  /* ── Guest mode: replace hidden prices with login link ─────────────────── */
  function guestMode() {
    var sels = ['.price-list--lg', 'sale-price.text-subdued'];
    sels.forEach(function (sel) {
      document.querySelectorAll(sel).forEach(function (el) {
        if (el.nextElementSibling && el.nextElementSibling.classList.contains(LOGIN)) return;
        var a = document.createElement('a');
        a.href = '/account/login';
        a.className = LOGIN;
        a.textContent = 'Login for pricing →';
        el.insertAdjacentElement('afterend', a);
        el.style.display = 'none';
      });
    });
  }

  /* ── Logged-in mode: excl. VAT label ───────────────────────────────────── */
  function addLabel(el) {
    if (el.nextElementSibling && el.nextElementSibling.classList.contains(CLS)) return;
    var span = document.createElement('span');
    span.className = CLS;
    span.textContent = 'excl. VAT';
    span.style.cssText = 'display:block;font-size:.7em;font-weight:500;letter-spacing:.06em;text-transform:uppercase;opacity:.45;margin-top:.15em;line-height:1';
    el.insertAdjacentElement('afterend', span);
  }

  function labelMode() {
    document.querySelectorAll('sale-price.text-lg').forEach(addLabel);
    document.querySelectorAll('sale-price.text-subdued').forEach(addLabel);
  }

  function run() {
    if (isGuest()) {
      guestMode();
    } else {
      labelMode();
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }

  document.addEventListener('variant:changed', run);

  var timer;
  new MutationObserver(function () {
    clearTimeout(timer);
    timer = setTimeout(run, 100);
  }).observe(document.querySelector('main') || document.body, { childList: true, subtree: true });
})();